<template>
    <svg xmlns="http://www.w3.org/2000/svg" :class="className">
        <title v-if="title">{{ title }}</title>
        <use :href.attr="`#${name}`" xmlns:xlink="http://www.w3.org/1999/xlink" />
    </svg>
</template>

<script setup>
import { onMounted, watch } from 'vue';
import { requestSvgSymbol } from '@utils/svgSpriteAsyncLoader';

const props = defineProps({
    name: {
        type: String,
        required: true,
    },
    title: {
        type: String,
        default: undefined,
    },
    className: {
        type: Object,
        default: () => ({}),
    },
});

function addSymbol() {
    requestSvgSymbol(props.name);
}

watch(() => props.name, addSymbol);
onMounted(addSymbol);
</script>
